import { urlFormatter } from "sb-resp-utils";
export const mapLinkUrl = (ajustLive, ajustPreLive, x) => {
    x.linkUrl = "";
    let url = urlFormatter.getEventUrl(x);
    if (x.isLive) {
        x.linkUrl = ajustLive(url);
    }
    else {
        x.linkUrl = ajustPreLive(url);
    }
    return x;
};
//# sourceMappingURL=mapLinkURL.js.map